/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import PropTypes from 'prop-types';

import styles from './Navigation.module.scss';

const closeMenuIcon = require('./imgs/menu-close.svg');

const options = ['Account', 'Settings', 'Alerts', 'Notes', 'Help'];

const Navigation = ({ toggleNav, toggleAlerts }) => (
  <div className={styles.navContainer}>
    <span onClick={() => toggleNav(false)} className={styles.closeButton}>
      <img src={closeMenuIcon} alt="nav-close" />
    </span>
    <div className={styles.navItems}>
      {options.map((option) => (
        <span key={option}>
          <a
            onClick={option === 'Alerts' ? (e) => {
              e.preventDefault();
              toggleAlerts();
            } : null}
            href="/feature"
          >
            {option}
          </a>
        </span>
      ))}
    </div>
  </div>
);

Navigation.propTypes = {
  toggleNav: PropTypes.func.isRequired,
  toggleAlerts: PropTypes.func.isRequired,
};

export default Navigation;
